import * as React from "react";
import AppIcon from "../components/AppIcon";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/OidcAuthProvider";

const AuthCallback: React.FC = () => {
    const { handleSignInCallback, error } = useAuth();
    const navigate = useNavigate();

    React.useEffect(() => {
        let active = true;
        handleSignInCallback()
            .then((returnTo) => {
                if (!active) {
                    return;
                }
                const target = returnTo ?? "/tickets";
                navigate(target, { replace: true });
            })
            .catch(() => {
                if (active) {
                    navigate("/tickets", { replace: true });
                }
            });

        return () => {
            active = false;
        };
    }, [handleSignInCallback, navigate]);

    return (
        <div
            className="min-h-screen bg-cover bg-center bg-no-repeat bg-fixed"
            style={{
                backgroundImage: "url(/images/collectivebg-2.jpg)",
            }}
        >
            <div className="min-h-screen backdrop-blur-sm flex items-center justify-center" style={{ backgroundColor: "rgba(241, 245, 248, 0.9)" }}>
                <div className="bg-white bg-opacity-60 backdrop-blur-sm rounded-2xl p-8 shadow-lg text-center space-y-6" style={{ borderLeft: `4px solid #DB1C7D` }}>
                    <div className="mb-4">
                        <span className="text-6xl"><AppIcon kind="lock" /></span>
                    </div>
                    <div className="mb-4">
                        <div className="animate-spin rounded-full h-12 w-12 border-4 border-transparent mx-auto" style={{ borderTopColor: "#DB1C7D" }}></div>
                    </div>
                    <h1 className="text-xl font-bold" style={{ color: "#013A51" }}>Completing sign-in</h1>
                    <p className="text-sm" style={{ color: "#708372" }}>Please wait while we verify your account.</p>
                    {error && (
                        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                            <p className="text-sm text-red-600">{error}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AuthCallback;
